import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOnGetAccountsByDateReportDTO from "../../../../models/DTO/IOnGetAccountsByDateReportDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwButton from "../../../shared/OwButton/OwButton";
import { OwDivTable } from "../../../shared/OwDivTable/OwDivTable";
import IOwDivTableCols from "../../../shared/OwDivTable/IOwDivTableCols";
import IVendorModel from "../../../../models/IVendorModel";
import ExcelJS from 'exceljs/dist/exceljs.min.js';
import moment from "moment-timezone";
import IProcessed_Report from "../../../../models/IProcessed_Report";

type Props = {
    processedReport: IProcessed_Report;
};

export const AccountsByDateReport: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const renderNo = (row: Partial<IVendorModel>, index: number) => {
        return <div>{index + 1}</div>;
    };

    const renderName = (row: Partial<IVendorModel>, index: number) => {
        return (
            <div>
                <div>{row.name}</div>
                <div>{row.customer_internal_id}</div>
            </div>
        );
    };

    const renderCityState = (row: Partial<IVendorModel>, index: number) => {
        return (
            <div>
                <div>
                    {row.Ship_To?.city}
                    {row.Ship_To?.city ? "," : ""}
                    {row.Ship_To?.state}
                </div>
            </div>
        );
    };

    const getTableCols = (): IOwDivTableCols[] => {
        return [
            {
                title: "no",
                renderFn: renderNo,
                className: "w-5",
            },
            {
                title: "name",
                renderFn: renderName,
                className: "w-25",
            },
            {
                title: "city_state",
                renderFn: renderCityState,
                className: "w-25",
            },
        ];
    };

    const [reportData, setReportData] = useState<IOnGetAccountsByDateReportDTO>();
    const [tableCols, setTableCols] = useState<IOwDivTableCols[]>(getTableCols());

    useEffect(() => {
        onGetAccountsByDateReport(props.processedReport.report_data);
    }, []);

    const getReport = () => {
        // if (props.periodType) {
        //     const payload: IGetAccountsByDateReportDTO = {
        //         userGuid: userModel.guid,
        //         userToken: userModel.token,
        //         supplierGuid: supplierModel.guid,
        //         periodType: props.periodType,
        //     };
        //
        //     props.socket.emit(EndpointsEnum.ReportGetAccountsByDateReport, payload);
        // }
    };

    const onGetAccountsByDateReport = (data: IOnGetAccountsByDateReportDTO) => {
        setReportData(data);
    };

    const downloadExcel = () => {
        if (reportData) {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet("Commissions");

            const salesPeopleWs: { salesperson: string; ws: ExcelJS.Worksheet }[] = [];

            const columns: (
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
            )[] = [
                { header: "Created At", key: "createdAt" },
                { header: "Name", key: "name" },
                { header: "Internal Id", key: "internalId" },
                { header: "City", key: "city" },
                { header: "State", key: "state" },
                { header: "Salesperson", key: "salesPerson" },
            ];

            if (supplierModel.has_rep_groups) {
                columns.push({ header: "Rep Group", key: "repGroup" });
            }

            ws.columns = columns;

            ws.getCell("A1").font = {
                bold: true,
            };

            ws.getCell("B1").font = {
                bold: true,
            };

            ws.getCell("C1").font = {
                bold: true,
            };

            ws.getCell("D1").font = {
                bold: true,
            };

            ws.getCell("E1").font = {
                bold: true,
            };

            ws.getCell("F1").font = {
                bold: true,
            };

            ws.getCell("G1").font = {
                bold: true,
            };

            for (const account of reportData.results) {
                const name = account?.name;
                const internalId = account?.customer_internal_id;
                const city = account?.Ship_To?.city || "";
                const state = account?.Ship_To?.state || "";
                // @ts-expect-error
                const salesPerson = account?.sales_person || "";
                // @ts-expect-error
                const repGroup = account?.rep_group || "";
                const createdAt = moment(account?.created_at).utc().format("MM/DD/YYYY");

                ws.addRow({ createdAt, name, internalId, city, state, salesPerson, repGroup });
            }

            const periodStart = moment(reportData.periodStart).format("YYYY-MM-DD");
            const periodEnd = moment(reportData.periodEnd).format("YYYY-MM-DD");

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `${periodStart}-${periodEnd}-orderwerks-accounts-by-date.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    return (
        <div className={"AccountsByDateReport"}>
            {reportData && reportData.results.length > 0 ? <OwButton title={"export_to_excel"} fn={downloadExcel} /> : null}
            <div>
                <OwLabel title={"total_records"} postText={":"} isBold={true} className={"me-2 mb-2 mt-2"} />
                {reportData?.results.length}
            </div>

            <div className={"mb-5"}>
                <OwDivTable cols={tableCols} data={reportData?.results || []} />
            </div>
        </div>
    );
};
